import React from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import SettingsIcon from "@mui/icons-material/Settings";
import NotificationsIcon from "@mui/icons-material/Notifications";

const Header = ({ profile }) => {
    const navigate = useNavigate();
    const location = useLocation();

    if (location.pathname === "/txmd5") {
        return null;
    }

    return (
        <div className="header" style={{ 
            backgroundColor: "#2c2828",     // ← Màu nền header (anh có thể đổi màu ở đây)
            borderBottom: "1px solid #333" 
        }}>
            <div className="logo">
                <Link to="/">
                    <img alt="" src="/images/logo.png" />
                </Link>
            </div>
            <div className="header-right" onClick={() => navigate("/profile")}>
                {profile ? (
                    <>
                        {/* Có thể thêm icon thông báo, setting sau */}
                    </>
                ) : (
                    <>
                        <Link to="/login" className="btn-login" style={{ marginBottom: "0" }}>
                            Đăng nhập
                        </Link>
                        <Link to="/register" className="btn-register" style={{ marginBottom: "0" }}>
                            Đăng ký
                        </Link>
                    </>
                )}
            </div>
        </div>
    );
};

export default Header;